var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTotalDuration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_7461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1795 11.1794C11.8396 10.5264 12.9085 10.5264 13.5067 11.1794L19.1309 16.8037C19.8476 17.4638 19.8476 18.5327 19.1309 19.1309C18.5327 19.8476 17.4638 19.8476 16.8037 19.1309L11.1795 13.5066C10.5264 12.9085 10.5264 11.8396 11.1795 11.1794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7507 2.24934C15.7507 1.00698 16.7559 0 18 0C27.9424 0 36 8.05761 36 18C36 27.9424 27.9424 36 18 36C8.05761 36 0 27.9424 0 18C0 12.9651 2.07059 8.40979 5.40301 5.14286C6.28965 4.27392 7.71429 4.28807 8.585 5.17471C9.45748 6.06312 9.44332 7.48776 8.5496 8.36024C6.04896 10.8078 4.50044 14.2251 4.50044 18C4.50044 25.4524 10.4839 31.4996 18 31.4996C25.5161 31.4996 31.4996 25.4524 31.4996 18C31.4996 11.3139 26.6345 5.75696 20.2493 4.68626V6.74978C20.2493 7.9939 19.2441 8.99911 18 8.99911C16.7559 8.99911 15.7507 7.9939 15.7507 6.74978V2.24934Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_7461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTotalDuration);
export default __webpack_public_path__ + "static/media/ic_total_duration.f7ac500d307cb1f5e92c56248e0b0f5f.svg";
export { ForwardRef as ReactComponent };